// import { memo } from "react";
// import Image from "next/image";
// import { useRouter } from "next/router";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import { addDofollowToAnchors } from "../utils/modifyHtmlLinks";

// const Process = memo(({ title, processData, className = "" }) => {
//   const router = useRouter();
//   const lang = router.locale || "en";
//   return (
//     <section
//       className={`w-full flex flex-col items-start justify-start pt-0 pb-[40px] lg:pb-[60px] px-6 sm:px-6 lg:px-20 box-border gap-6 md:gap-10  text-text-primary max-w-[1600px] mx-auto ${className}`}
//     >
//       {/* Heading + Arrows */}
//       <div className="w-full flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6">
//         <h2 className=" font-medium text-[28px] sm:text-[32px] lg:text-[40px] leading-[120%] m-0 capitalize">
//           {title}
//         </h2>
//         {lang === "ar" ? (
//           <div className="flex items-center gap-4">
//             <div className="swiper-button-next-custom cursor-pointer">
//               <Image
//                 src="/next@2x.png"
//                 alt="Next"
//                 width={44}
//                 height={44}
//                 className="h-11 w-11 object-contain"
//               />
//             </div>
//             <div className="swiper-button-prev-custom cursor-pointer">
//               <Image
//                 src="/back-1@2x.png"
//                 alt="Prev"
//                 width={44}
//                 height={44}
//                 className="h-11 w-11 object-contain"
//               />
//             </div>
//           </div>
//         ) : (
//           <div className="flex items-center gap-4">
//             <div className="swiper-button-prev-custom cursor-pointer">
//               <Image
//                 src="/back-1@2x.png"
//                 alt="Prev"
//                 width={44}
//                 height={44}
//                 className="h-11 w-11 object-contain"
//               />
//             </div>
//             <div className="swiper-button-next-custom cursor-pointer">
//               <Image
//                 src="/next@2x.png"
//                 alt="Next"
//                 width={44}
//                 height={44}
//                 className="h-11 w-11 object-contain"
//               />
//             </div>
//           </div>
//         )}
//       </div>
//       {/* Swiper Process */}
//       <Swiper
//         dir={lang === "ar" && "ltr"}
//         modules={[Navigation, Autoplay]}
//         spaceBetween={16}
//         slidesPerView={1}
//         breakpoints={{
//           640: {
//             slidesPerView: 1,
//           },
//           768: {
//             slidesPerView: 2,
//           },
//           1024: {
//             slidesPerView: 4.2,
//           },
//           1028: {
//             slidesPerView: 4.2,
//           },
//         }}
//         autoplay={{ delay: 5000 }}
//         navigation={{
//           nextEl: ".swiper-button-next-custom",
//           prevEl: ".swiper-button-prev-custom",
//         }}
//         className="w-full"
//       >
//         {processData?.map((project, i) => (
//           <SwiperSlide key={i}>
//             <div
//               className="w-full h-full rounded-3xl border-gray-500 border-solid border-[1px] box-border shrink-0 flex flex-col items-start justify-start py-[38px] pl-6 pr-5 gap-[40px]"
//               dir={lang === "ar" ? "rtl" : "ltr"}
//             >
//               <Image
//                 className="w-11 h-11 relative overflow-hidden shrink-0"
//                 loading="lazy"
//                 width={44}
//                 height={44}
//                 alt="icon"
//                 src="/carbongrowth2.svg"
//               />
//               <div className="flex flex-col items-start justify-start gap-4 w-full max-w-full">
//                 <h3 className="m-0 relative text-[18px] lg:text-[24px] leading-[140%] font-medium">
//                   {project?.point}
//                 </h3>
//                 <div
//                   className="text-[16px] leading-[150%] m-0 rich-text"
//                   dangerouslySetInnerHTML={{
//                     __html: addDofollowToAnchors(project?.description) || "",
//                   }}
//                 />
//                 {/* {project?.description}
//                 </p> */}
//               </div>
//             </div>
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </section>
//   );
// });

// export default Process;

import { memo } from "react";
import { useRouter } from "next/router";
import { addDofollowToAnchors } from "../utils/modifyHtmlLinks";

const Process = memo(({ title, processData, className = "" }) => {
  const router = useRouter();
  const lang = router.locale || "en";
  return (
    <section
      className={`w-full flex flex-col items-center justify-start pt-0 pb-[40px] lg:pb-[60px] px-6 sm:px-6 lg:px-20 box-border gap-6 md:gap-10  text-text-primary max-w-[1600px] mx-auto ${className}`}
    >
      {/* Heading + Arrows */}
      <h2 className=" font-medium text-[28px] sm:text-[32px] lg:text-[40px] leading-[120%] m-0 capitalize">
        {title}
      </h2>
      {/* Process Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-y-6 gap-x-6 rounded-[24px]">
        {processData?.map((project, index) => (
          <div
            key={index}
            className="bg-white rounded-[24px] w-full flex flex-col gap-4 box-border"
            style={{
              // maxWidth: "410px",
              // maxHeight: "300px",
              paddingTop: "24px",
              paddingRight: "16px",
              paddingBottom: "24px",
              paddingLeft: "16px",
              border: "1px solid #0000003D",
            }}
          >
            {/* Number */}
            <div
              style={{
                fontFamily: "DM Sans, ui-sans-serif, system-ui",
                fontWeight: 500,
                fontSize: "40px",
                lineHeight: "120%",
                letterSpacing: "0%",
                color: "#F64A62",
              }}
            >
              {String(index + 1).padStart(2, "0")}
            </div>

            {/* Title */}
            <h3 className="m-0 relative text-[18px] lg:text-[24px] leading-[140%] font-medium">
              {project?.point}
            </h3>

            {/* Description */}
            <div
              className="text-[16px] leading-[150%] m-0 rich-text"
              dangerouslySetInnerHTML={{
                __html: addDofollowToAnchors(project?.description) || "",
              }}
            />
          </div>
        ))}
      </div>
    </section>
  );
});

export default Process;
